import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const TestService = {
  deactivateTest: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TEST.DEACTIVATETEST, {
      id,
    });
    const response = await api.patch(endpoint);
    return response;
  },
  deactivateTestGroup: async (id) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTGROUP.DEACTIVATETESTGROUP,
      {
        id,
      }
    );
    const response = await api.patch(endpoint);
    return response;
  },
  deactivateTestCollection: async (id) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.DEACTIVATETESTCOLLECTION,
      {
        id,
      }
    );
    const response = await api.patch(endpoint);
    return response;
  },
  publishTest: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TEST.PUBLISHTEST, {
      id,
    });
    const response = await api.put(endpoint);
    return response;
  },
  publishTestGroup: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TESTGROUP.PUBLISHTESTGROUP, {
      id,
    });
    const response = await api.put(endpoint);
    return response;
  },
  publishTestCollection: async (id, orgId) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.PUBLISHTESTCOLLECTION,
      {
        id,
      }
    );
    const response = await api.put(endpoint, { org_id: orgId });
    return response;
  },
  newTest: async (data) => {
    const response = await api.post(API_ENDPOINTS.TEST.NEWTEST, data);
    return response;
  },
  updateTest: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TEST.UPDATETEST, {
      id,
    });
    const response = await api.put(endpoint, data);

    return response;
  },
  getTest: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TEST.GETTEST, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
  listTests: async (pageNo, pageSize, search, status) => {
    let endpoint = createEndpoint(API_ENDPOINTS.TEST.LISTTESTS, {
      pageNo,
      pageSize,
      search,
      status: '', // Remove single status placeholder
    });

    // Build query string with multiple status parameters
    if (Array.isArray(status) && status.length > 0) {
      const statusParams = status.map((s) => `status=${s}`).join('&');
      endpoint = endpoint.replace(/&status=$/, ''); // Remove empty status param
      endpoint = `${endpoint}&${statusParams}`;
    }

    const response = await api.get(endpoint);
    return response;
  },
  listAllTests: async (pageNo, pageSize, search, status) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TEST.LISTALLTESTS, {
      pageNo,
      pageSize,
      search,
      status,
    });
    const response = await api.get(endpoint);
    return response;
  },
  newTestGroup: async (data) => {
    const response = await api.post(API_ENDPOINTS.TESTGROUP.NEWTESTGROUP, data);
    return response;
  },

  updateTestGroup: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TESTGROUP.UPDATETESTGROUP, {
      id,
    });
    const response = await api.put(endpoint, data);
    return response;
  },

  getTestGroup: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TESTGROUP.GETTESTGROUP, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },

  listTestGroups: async (pageNo, pageSize, search, status) => {
    let endpoint = createEndpoint(API_ENDPOINTS.TESTGROUP.LISTTESTSGROUP, {
      pageNo,
      pageSize,
      search,
      status: '', // Remove single status placeholder
    });

    // Build query string with multiple status parameters
    if (Array.isArray(status) && status.length > 0) {
      const statusParams = status.map((s) => `status=${s}`).join('&');
      endpoint = endpoint.replace(/&status=$/, ''); // Remove empty status param
      endpoint = `${endpoint}&${statusParams}`;
    }

    const response = await api.get(endpoint);
    return response;
  },
  listAllTestGroups: async (pageNo, pageSize, search, status) => {
    const endpoint = createEndpoint(API_ENDPOINTS.TESTGROUP.LISTALLTESTSGROUP, {
      pageNo,
      pageSize,
      search,
      status,
    });
    const response = await api.get(endpoint);
    return response;
  },
  newTestCollection: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.TESTCOLLECTION.NEWTESTCOLLECTION,
      data
    );
    return response;
  },

  updateTestCollection: async (id, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.UPDATETESTCOLLECTION,
      { id }
    );
    const response = await api.put(endpoint, data);
    return response;
  },

  getTestCollection: async (id) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.GETTESTCOLLECTION,
      {
        id,
      }
    );
    const response = await api.get(endpoint);
    return response;
  },

  listTestCollections: async (pageNo, pageSize, search, status) => {
    let endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.LISTTESTSCOLLECTION,
      {
        pageNo,
        pageSize,
        search,
        status: '', // Remove single status placeholder
      }
    );

    // Build query string with multiple status parameters
    if (Array.isArray(status) && status.length > 0) {
      const statusParams = status.map((s) => `status=${s}`).join('&');
      endpoint = endpoint.replace(/&status=$/, ''); // Remove empty status param
      endpoint = `${endpoint}&${statusParams}`;
    }

    const response = await api.get(endpoint);
    return response;
  },

  updateCollectionRules: async (collectionId, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.TESTCOLLECTION.UPDATECOLLECTIONRULES,
      { id: collectionId }
    );
    const response = await api.put(endpoint, data);
    return response;
  },
};
